import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PwResetModel } from 'src/app/_models/pwreset.model';
import { PwresetService } from 'src/app/_services/pwreset.service';
import { BaseComponent } from '../../base/base.component';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { StorageService } from 'src/app/_services/storage.service';
import { User } from 'src/app/_models/user.model';
import { Routes } from 'src/app/_config/routes.config';

@Component({
  selector: 'DCO-pwreset',
  templateUrl: './pwreset.component.html',
  standalone: false,
  styleUrls: [],
})
export class PwresetComponent extends BaseComponent implements OnInit {
  constructor(
    public override router: Router,
    public override langService: LanguageManagerService,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private PwresetService: PwresetService
  ) {
    super(router, langService, route);
  }

  private userSuscription!: Subscription;
  isLoggedIn = false;
  blockButton = false;
  passwordResetOk = false;

  userLocal: string = '';
  userPassword: string = '';
  userConfirmPassword: string = '';
  parameters: any = {
    token: '',
    userName: '',
    password: '',
    confirmPassword: '',
    captchaValidation: '',
  };
  token;
  response: PwResetModel;
  error = new Array();
  counter;

  override ngOnInit(): void {
    super.ngOnInit();
    this.userSuscription = this.storageService.userInfo.subscribe((user) => {
      this.updateUserData(user);
    });
    this.route.queryParams.subscribe((params: Params) => {
      if (params.hasOwnProperty('Token') && params['Token']!='') {
        this.token = params['Token'];
      } else {
        this.router.navigate([Routes.DEFAULT]);
      }
    });
  }

  resetPW() {
    this.error = [];
    this.counter = 0;
 
    //this.token = this.router.url.split('=');
    this.blockButton = true;
    this.parameters.token = this.token;
    this.parameters.userName = this.userLocal;
    this.parameters.password = this.userPassword;
    this.parameters.confirmPassword = this.userConfirmPassword;
    // console.log(this.parameters);
    this.PwresetService.PwResetMethod(this.parameters).subscribe(
      (response) => {
        this.response = response;
        this.passwordResetOk = true;
      },
      (error) => {
        if (error.error == 'Token' && error.status == 401) {
          this.error.push(
            this.langService.translate('DCO.Password_Reset_Error_Token')
          );
        } else if (error.error.problems != null) {
          for (let i = 0; i < error.error.problems.length; i++) {
            this.error.push(
              this.langService.translate(
                'DCO.Password_Reset_Error_' + error.error.problems[i]
              )
            );
            // if (error.error.problems[i] == 'MinimalLengthNotReached') {
            //   this.error.push('La contraseña debe tener al menos 8 caracteres');
            // }
            // if (error.error.problems[i] == 'MayuscRequired') {
            //   this.error.push('La contraseña debe tener al menos 1 mayúscula');
            // }
            // if (error.error.problems[i] == 'MayuscRequired') {
            //   this.error.push('La contraseña debe tener al menos 1 minúscula');
            // }
            // if (error.error.problems[i] == 'SymbolRequired') {
            //   this.error.push('La contraseña debe tener al menos 1 símbolo');
            // }
            // if (error.error.problems[i] == 'NumberRequired') {
            //   this.error.push('La contraseña debe tener al menos 1 número');
            // }
          }
          if (error.status == 400 || error.status == 500) {
            this.counter = 1;
            this.error.push(
              this.langService.translate('DCO.Password_Reset_Error_General')
            );
          }
        }
        
    this.blockButton = false;
      }
    );
  }
  updateUserData(user: User) {
    if (user != null && user.user) {
      // console.log('updateUserData password reset');
      this.isLoggedIn = true;
      this.router.navigate([Routes.DEFAULT]);
    } else {
      this.isLoggedIn = false;
    }
  }
  NavigateLogin(){
    this.router.navigate([Routes.LOGIN]);
  }
}
